import React, {FC} from 'react';
import {View} from 'react-native';

import Gutter from '/component/layout/Gutter';
import {generateCallback} from '/util/component.util';

import {styles} from './ProgressTarget.style';

interface ProgressTargetProps {
  isComplete: boolean;
  data: object;
  dataComponent: React.ElementType;
  dataComponentProps: object;
  extendedDataComponent: React.ElementType;
  extendedDataComponentProps: object;
  hasExtendedDetail: boolean;
  detailVisible: boolean;
  showDetail: () => void;
  hideDetail: () => void;
  accessibilityLabel: string;
}

const ProgressTarget: FC<ProgressTargetProps> = ({
  isComplete = false,
  data = {},
  dataComponent: DataComponent = () => null,
  dataComponentProps = {},
  extendedDataComponent: ExtendedDataComponent = () => null,
  extendedDataComponentProps = {},
  hasExtendedDetail = false,
  detailVisible = false,
  showDetail = () => {},
  hideDetail = () => {},
  accessibilityLabel = '',
}: ProgressTargetProps) => {
  const onPress = detailVisible
    ? generateCallback({func: hideDetail})
    : generateCallback({func: showDetail});

  return (
    <View
      style={styles.base}
      accessible={true}
      accessibilityLabel={accessibilityLabel}>
      <DataComponent
        data={data}
        isComplete={isComplete}
        detailVisible={detailVisible}
        {...dataComponentProps}
        {...(hasExtendedDetail ? {onPress} : {})}
        accessibilityLabel={accessibilityLabel}
      />
      {hasExtendedDetail && detailVisible && (
        <Gutter style={styles.expandedDetail}>
          <ExtendedDataComponent
            {...extendedDataComponentProps}
            data={data}
            accessibilityLabel={accessibilityLabel}
          />
        </Gutter>
      )}
    </View>
  );
};

export default ProgressTarget;
